import ChildDetailsPage from '../pages/child-details';
import SignPage from '../pages/sign';
import EmailPage from '../pages/email';
import ConfirmPermissionPage from '../pages/confirm-permission';
import WaiverSignaturePage from '../pages/waiver-signature';
import HeightPage from '../pages/height';
import CompletePage from '../pages/complete';
import InvalidPage from '../pages/invalid';
import OrderCompletePage from '../pages/order-complete';

type PageRoute = {
  title: string;
  path: string;
  Component: React.FC<PageProps>;
  showContinue?: boolean;
};

export type PageProps = {
  title: string;
  showContinue?: boolean;
};

export const NY_HQ_VENUE_ID = 1;
export const LDN_CG_VENUE_ID = 3;

export const PATHS = {
  READY: 'ready',
  SIGN: 'sign',
  EMAIL: 'email',
  CHILD_DETAILS: 'child-details',
  CONFIRM_PERMISSION: 'confirm-permission',
  WAIVER_SIGNATURE: 'waiver-signature',
  CHILD_HEIGHT: 'child-height',
  COMPLETE: 'complete',
  INVALID: 'invalid',
  PARTY_ORDER_COMPLETE: 'party-order-complete',
  ORDER_COMPLETE: 'order-complete',
};

export const PAGE_ROUTES: PageRoute[] = [
  {
    title: 'Sign | SPYGAMES',
    path: PATHS.SIGN,
    Component: SignPage,
  },
  {
    title: 'Waiver Email | SPYGAMES',
    path: PATHS.EMAIL,
    Component: EmailPage,
  },
  {
    title: 'Child Details | SPYGAMES',
    path: PATHS.CHILD_DETAILS,
    Component: ChildDetailsPage,
  },
  {
    title: 'Confirm Permission | SPYGAMES',
    path: PATHS.CONFIRM_PERMISSION,
    Component: ConfirmPermissionPage,
  },
  {
    title: 'Waiver Signature | SPYGAMES',
    path: PATHS.WAIVER_SIGNATURE,
    Component: WaiverSignaturePage,
  },
  {
    title: 'Child Height | SPYGAMES',
    path: PATHS.CHILD_HEIGHT,
    Component: HeightPage,
  },
  {
    title: 'All set | SPYGAMES',
    path: PATHS.COMPLETE,
    Component: CompletePage,
  },
  {
    title: 'Invalid | SPYGAMES',
    path: PATHS.INVALID,
    Component: InvalidPage,
  },
  {
    title: 'Order Complete | SPYGAMES',
    path: PATHS.PARTY_ORDER_COMPLETE,
    Component: OrderCompletePage,
    showContinue: true,
  },
  {
    title: 'Order Complete | SPYGAMES',
    path: PATHS.ORDER_COMPLETE,
    Component: OrderCompletePage,
    showContinue: false,
  },
];
